export default "<div class=\"container\">\n  <div class=\"modal\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"